(function() {
    'use strict';
    //service must be lowercase since Plaid library attaches to window.Plaid
    angular.module('wbUtilities').provider('FullStory', [function () {

        //default options
        var options = {
            fs_org: '237SW'
        };

        /**
         * @param {Object} options
         * @param {string} options.clientId
         * @param {Array}  [options.scripts]
         * @param {Array}  [options.scopes]
         * @returns {*}
         */
        this.init = function(customOptions) {
            angular.extend(options, customOptions);
            options.onSuccess = function() {};
            return this;
        };

        this.$get = ['$window', '$location', function($window, $location) {

            var debug, fullStory = {
                loaded: false
            };

            debug = $location.host().replace("www.","") !== "wisebanyan.com";

            $window['_fs_debug'] = debug;
            $window['_fs_host'] = 'www.fullstory.com';
            $window['_fs_org'] = options.fs_org;
            $window['_fs_namespace'] = 'FS';

            fullStory.load = function() {

                (function(m,n,e,t,l,o,g,y){
                    if (e in m && m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'); return;}
                    g=m[e]=function(a,b){g.q?g.q.push([a,b]):g._api(a,b);};g.q=[];
                    o=n.createElement(t);o.async=1;o.src='https://'+_fs_host+'/s/fs.js';
                    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
                    g.identify=function(i,v){g(l,{uid:i});if(v)g(l,v)};g.setUserVars=function(v){g(l,v)};
                    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
                    g.clearUserCookie=function(c,d,i){if(!c || document.cookie.match('fs_uid=[`;`]*`[`;`]*`[`;`]*`')){
                        d=n.domain;while(1){n.cookie='fs_uid=;domain='+d+
                            ';path=/;expires='+new Date(0).toUTCString();i=d.indexOf('.');if(i<0)break;d=d.slice(i+1)}}};
                })(window,document,window['_fs_namespace'],'script','user');

                fullStory.loaded = true;
            };

            /**
             * @param {Object} data
             * @param {string} data.id
             * @param {string} data.displayName
             * @param {string} data.email
             * @returns {*}
             */
            fullStory.identify = function(data) {
                if (!fullStory.loaded) return;

                var id = data.id.toString(),
                    idData = {
                        displayName: data.name,
                        email: data.name
                    };

                angular.copy(data, idData);
                delete idData.id;

                FS.identify(id, idData);
            };

            fullStory.clear = function() {
                if (!fullStory.loaded) return;

                FS.clearUserCookie();
            };

            return fullStory;

        }];

        return this;

    }])

    // Initialization of module
    .run(['$rootScope', '$window', '$location', 'FullStory', function ($rootScope, $window, $location, FullStory) {

        if ($location.host().replace("www.","") === 'wisebanyan.com') {
            FullStory.load();
        }

    }]);

})();
